import React from 'react';
import { createStyles, Divider, Grid, makeStyles } from '@material-ui/core';
import { SignUpTerms } from './SignUpTerms';
import { SocialButtonContent } from './SocialButtonContent';
export var useSocialSignUpFormStyles = makeStyles(function (_a) {
    var spacing = _a.spacing, typography = _a.typography, palette = _a.palette;
    return createStyles({
        grid: {
            '& .MuiGrid-item': {
                marginBottom: spacing(1.5),
            },
        },
        formSeparator: {
            borderColor: palette.secondary.main,
            borderTopWidth: spacing(0.125),
            borderStyle: 'solid',
            height: spacing(0.125),
            margin: spacing(1.75, 0),
            '& p': {
                fontFamily: typography.fontFamily,
                color: palette.secondary.main,
                fontSize: typography.fontSize - 1,
                fontWeight: typography.fontWeightBold,
                textAlign: 'center',
                margin: spacing(-1.125, 'auto'),
                backgroundColor: palette.common.white,
                display: 'block',
                width: spacing(3.75),
            },
        },
        center: {
            textAlign: 'center',
            '&.MuiGrid-item': {
                marginBottom: function (_a) {
                    var hideLogin = _a.hideLogin;
                    return (hideLogin ? spacing(2) : spacing(1.5));
                },
            },
        },
        buttonLink: {
            borderStyle: 'none',
            background: 'none',
            fontFamily: typography.fontFamily,
            fontSize: typography.body2.fontSize,
            fontWeight: typography.fontWeightBold,
            color: palette.tertiary.main,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        member: {
            paddingTop: spacing(1.75),
            fontFamily: typography.fontFamily,
            fontSize: typography.body1.fontSize,
        },
        separator: {
            '& hr': {
                backgroundColor: palette.secondary.main,
                margin: spacing(1.75, 0),
            },
        },
        terms: {
            '&.MuiGrid-item': {
                marginBottom: 0,
            },
        },
        gr_loh_rd_formSeparator: {
            borderColor: palette.border.disabled,
            borderTopWidth: spacing(0.125),
            borderStyle: 'solid',
            height: spacing(0.125),
            margin: spacing(1.75, 0),
            '& p': {
                fontFamily: typography.fontFamily,
                color: palette.border.disabled,
                fontSize: typography.fontSize - 1,
                fontWeight: typography.fontWeightBold,
                textAlign: 'center',
                margin: spacing(-1.125, 'auto'),
                backgroundColor: palette.secondary.main,
                display: 'block',
                width: spacing(3.75),
            },
        },
        gr_loh_rd_buttonLink: {
            borderStyle: 'none',
            background: 'none',
            fontFamily: typography.fontFamily,
            fontSize: typography.body2.fontSize,
            fontWeight: typography.fontWeightBold,
            color: palette.primary.main,
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        gr_loh_rd_separator: {
            '& hr': {
                backgroundColor: palette.border.disabled,
                margin: spacing(1.75, 0),
            },
        },
        gr_loh_rd_member: {
            paddingTop: spacing(1.75),
            fontFamily: typography.fontFamily,
            fontSize: typography.body1.fontSize,
            color: palette.border.disabled,
        },
    });
});
export function SocialSignUpForm(props) {
    var redirectTo = props.redirectTo, _a = props.hideLogin, hideLogin = _a === void 0 ? false : _a, _b = props.excludeTitle, excludeTitle = _b === void 0 ? false : _b, switchToEmailSignUp = props.switchToEmailSignUp, _c = props.switchToLogin, switchToLogin = _c === void 0 ? function () { } : _c, _d = props.isLoggedOutHomeRedesign, isLoggedOutHomeRedesign = _d === void 0 ? false : _d;
    var classes = useSocialSignUpFormStyles(props);
    var handleEmailSignUp = function (event) {
        event.preventDefault();
        switchToEmailSignUp(true);
    };
    var handleLogin = function (event) {
        event.preventDefault();
        switchToLogin(true);
    };
    return (React.createElement(Grid, { container: true, className: classes.grid },
        React.createElement(SocialButtonContent, { redirectTo: redirectTo, isSignUp: true, isLoggedOutHomeRedesign: isLoggedOutHomeRedesign }),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement("div", { className: "form-separator " + (isLoggedOutHomeRedesign ? classes.gr_loh_rd_formSeparator : classes.formSeparator) },
                React.createElement("p", null, "or"))),
        React.createElement(Grid, { item: true, xs: 12, className: classes.center }, isLoggedOutHomeRedesign ? (React.createElement("button", { className: classes.gr_loh_rd_buttonLink, onClick: handleEmailSignUp }, "Sign Up With Email")) : (React.createElement("button", { className: classes.buttonLink, onClick: handleEmailSignUp }, excludeTitle ? 'Sign up using Email' : 'Sign Up Using Email'))),
        !hideLogin && (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 12, className: classes.center },
                React.createElement("div", { className: isLoggedOutHomeRedesign ? classes.gr_loh_rd_member : classes.member },
                    "Already a member?\u00A0",
                    React.createElement("button", { className: isLoggedOutHomeRedesign ? classes.gr_loh_rd_buttonLink : classes.buttonLink, onClick: handleLogin }, "Sign In"))),
            React.createElement(Grid, { item: true, xs: 12, className: isLoggedOutHomeRedesign ? classes.gr_loh_rd_separator : classes.separator },
                React.createElement(Divider, null)))),
        React.createElement(Grid, { className: classes.terms, item: true, xs: 12 },
            React.createElement(SignUpTerms, { hideCaptchaTerms: true, isLoggedOutHomeRedesign: isLoggedOutHomeRedesign }))));
}
//# sourceMappingURL=SocialSignUpForm.js.map